import createIcon from '../../createIcon';

/**
 * @component @name PlaylistAddCheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA5LjVIMi41VjExLjVIMTMuNVY5LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuNSA1LjVIMi41VjcuNUgxMy41VjUuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05LjUgMTMuNUgyLjVWMTUuNUg5LjVWMTMuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMC4wOSAxMS40M0wxNS44NCAxNS42N0wxMy43MiAxMy41NUwxMi4zMSAxNC45NkwxNS44NCAxOC41TDIxLjUgMTIuODRMMjAuMDkgMTEuNDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlaylistAddCheck = createIcon('PlaylistAddCheck', [
  ['path', { d: 'M13.5 9.5H2.5V11.5H13.5V9.5Z', key: 'g0yqg1' }],
  ['path', { d: 'M13.5 5.5H2.5V7.5H13.5V5.5Z', key: '1bblcm' }],
  ['path', { d: 'M9.5 13.5H2.5V15.5H9.5V13.5Z', key: '1s7x5x' }],
  [
    'path',
    {
      d: 'M20.09 11.43L15.84 15.67L13.72 13.55L12.31 14.96L15.84 18.5L21.5 12.84L20.09 11.43Z',
      key: '18deeg',
    },
  ],
]);

export default PlaylistAddCheck;
